import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import React from 'react';
import { Col, Row } from 'antd';
import { Typography, VertContainer, VertIcon } from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';
import { formatToCNPJ } from 'Utils/format';
import { useMediaQuery } from 'react-responsive';

export const SpotSupplierInfo = ({ spot, callModalDocuments }) => {
  const filter =
    spot.files !== null
      ? spot.files.filter((files) => files.type === 1 && files)
      : [];
  const mediaQuery = useMediaQuery({ query: '(max-width: 768px)' });

  return (
    filter !== null &&
    filter.length > 0 && (
      <>
        <VertContainer className="container-subtitle-view-redemption">
          <VertIcon
            size="large"
            className="spacing-icon"
            isVertice
            iconName="Store"
          />
          <Typography.Text className="subtitle-view-redemption">
            Fornecedor
          </Typography.Text>
        </VertContainer>

        <Row className="container-summary-view-redemption" gutter={[32, 32]}>
          <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
            <VertContainer className="container-details-view-redemption">
              <Typography.Text className="text-view-redemption font-weight-700">
                Nome do Fornecedor
              </Typography.Text>

              <Typography.Text className="text-view-redemption">
                {spot.supplierReference !== null &&
                spot.supplierReference.companyName !== null
                  ? spot.supplierReference.companyName
                  : 'Não informado'}
              </Typography.Text>
            </VertContainer>
          </Col>

          <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
            <VertContainer className="container-details-view-redemption">
              <Typography.Text className="text-view-redemption font-weight-700">
                CNPJ do Fornecedor
              </Typography.Text>

              <Typography.Text className="text-view-redemption">
                {spot.supplierReference !== null &&
                spot.supplierReference.document !== null
                  ? formatToCNPJ(spot.supplierReference.document)
                  : 'Não informado'}
              </Typography.Text>
            </VertContainer>
          </Col>
        </Row>
      </>
    )
  );
};

SpotSupplierInfo.propTypes = {
  spot: PropTypes.object.isRequired,
  callModalDocuments: PropTypes.func,
};
